import React, { ReactElement } from 'react';
import { ITSTooltipProps } from './types';
import { SCTooltip } from './styles';

/***
 * Our wrapper around the MaterialUI Tooltip, with app-specific styling built in
 */
const TSTooltip = ({ title, children, placement = 'right', arrow = true }: ITSTooltipProps): ReactElement => {
    return (
        <SCTooltip
            title={title}
            arrow={arrow}
            placement={placement}
            componentsProps={{
                tooltip: {
                    sx: {
                        backgroundColor: 'white',
                        color: '#000000',
                        border: '1px solid #ddd',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                        fontSize: '0.8125rem',
                        whiteSpace: 'pre-line',
                        padding: '8px 12px',
                        borderRadius: '4px'
                    }
                },
                arrow: {
                    sx: {
                        color: 'white',
                        '&::before': {
                            borderColor: '#ddd'
                        }
                    }
                }
            }}
        >
            {children}
        </SCTooltip>
    );
};

export default TSTooltip;
